export const getAriaLabelsForControl = (id, error, errorMessage, hint) => ({
    describeId: `describe-${id}`,
    ariaDescribedBy: (error && errorMessage) || hint ? `describe-${id}` : undefined,
});
//# sourceMappingURL=index.js.map